import { t } from '@repo/i18n';
import { useLocale } from '@repo/i18n/react';
import { cn } from '../../lib/utils';
import { Spinner } from '../ui/spinner';
import type { ImageLoadingState } from './pdf-viewer-types';

type PdfViewerPageImageProps = {
  imageLoadingState: ImageLoadingState;
  imageProps: React.ImgHTMLAttributes<HTMLImageElement> & Record<string, unknown> & { alt: '' };
};

export const PdfViewerPageImage = ({ imageLoadingState, imageProps }: PdfViewerPageImageProps) => {
  useLocale();

  return (
    <>
      {/* Loading State */}
      {imageLoadingState === 'loading' && (
        <div className="absolute inset-0 z-10 flex items-center justify-center text-muted-foreground opacity-20">
          <Spinner />
        </div>
      )}

      {imageLoadingState === 'error' && (
        <div className="absolute inset-0 z-10 flex items-center justify-center">
          <p>{t('ui.errorLoadingPage')}</p>
        </div>
      )}

      {/* The PDF image. */}
      {imageProps.src && (
        <img
          {...imageProps}
          alt=""
          className={cn(imageProps.className, 'select-none')}
          draggable={false}
        />
      )}
    </>
  );
};
